export default __webpack_public_path__ + "static/card-three-f9257f70a70f8bb49f117bbec49a6dbd.jpg";